<template>
    <div>
        <b-card class="bg-card">
            <div v-if="role.includes('staff') || role.includes('faculty')">
                <b-row  order="1"  no-gutters>
                    <b-col class="mb-3" :sm="MaxScale === 'Monitor' ? 1 : 4">
                        <div :class="{'' : MaxScale === 'Monitor' ,'text-center' : MaxScale === 'miniMonitor'}">
                            <div class="card text-white card-profileImage">
                                <div class="text-center">
                                    <img v-if="imageView !== ''" :src="imageView" class="align-middle mr-2 rounded-circle img-thumbnail imgStyle" alt="avatar.png">
                                    <img v-else src="@/assets/img/avatar.png"  class="align-middle mr-2 rounded-circle img-thumbnail imgStyle"  alt="avatar.png">
                                </div>
                                <div  class="card-img-overlay text-center">
                                    <span ><p class="mt-5 mb-1"></p><br><br></span>
                                    <b-badge class="mt-3" variant="dark">
                                        <b-link 
                                            class="font-btn-upload f-500" 
                                            :class="{'ml-0' : MaxScale === 'miniMonitor'}"
                                            size="sm" 
                                            @click="$refs.fileInput2.$el.querySelector('input[type=file]').click()"
                                        >
                                            <span class="text-white"><i class="mt-2 mb-2 fa fa-picture-o" aria-hidden="true"></i>Update</span>
                                        </b-link>
                                    </b-badge>
                                    <b-form-file  ref="fileInput2" @change="UploadProfile" v-model="photoProfile" style="display:none;" />
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col :sm="MaxScale === 'Monitor' ? 11 : 8">
                        <b-card-body>
                            <b-card-text>
                                <h5 class="mb-1 profile-font">
                                    <b>Name :</b> {{ $keycloak.fullName }}
                                </h5>
                                <p  class="mt-2 mt-0 mb-1 profile-font">
                                    <b>E-mail :</b> {{ $keycloak.tokenParsed.email }}
                                </p>
                                <p  class="mt-2 mt-0 mb-1 profile-font">
                                    <b>MUIC Account :</b> {{ $keycloak.userName }}
                                </p>
                                <p  class="mt-0 mb-1 profile-font">
                                    <b>MU Account :</b> 
                                </p>
                            </b-card-text>
                        </b-card-body>
                    </b-col>
                </b-row>
            </div>
            <div v-if="role.includes('student')">
                <b-row  order="1"  no-gutters>
                    <b-col class="mb-3" :sm="MaxScale === 'Monitor' ? 1 : 4">
                        <div :class="{'' : MaxScale === 'Monitor' ,'text-center' : MaxScale === 'miniMonitor'}">
                            <div class="card text-white card-profileImage">
                                <div class="text-center">
                                    <img v-if="imageView !== ''" :src="imageView" class="align-middle mr-2 rounded-circle img-thumbnail imgStyle" alt="avatar.png">
                                    <img v-else src="@/assets/img/avatar.png"  class="align-middle mr-2 rounded-circle img-thumbnail imgStyle"  alt="avatar.png">
                                </div>
                                <div  class="card-img-overlay text-center">
                                    <span ><p class="mt-5 mb-1"></p><br><br></span>
                                    <b-badge class="mt-3" variant="dark">
                                        <b-link 
                                            class="font-btn-upload f-500" 
                                            :class="{'ml-0' : MaxScale === 'miniMonitor'}"
                                            size="sm" 
                                            @click="$refs.fileInput2.$el.querySelector('input[type=file]').click()"
                                        >
                                            <span class="text-white"><i class="mt-2 mb-2 fa fa-picture-o" aria-hidden="true"></i>Update</span>
                                        </b-link>
                                    </b-badge>
                                    <b-form-file  ref="fileInput2" @change="UploadProfile" v-model="photoProfile" style="display:none;" />
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col :sm="MaxScale === 'Monitor' ? 11 : 8">
                        <b-card-body>
                            <b-card-text>
                                <h5 class="mb-1 profile-font">
                                    <b>Name :</b> {{ $keycloak.fullName }}
                                </h5>
                                <p  class="mt-2 mt-0 mb-1 profile-font">
                                    <b>E-mail :</b> {{ $keycloak.tokenParsed.email }}
                                </p>
                                <p  class="mt-2 mt-0 mb-1 profile-font">
                                    <b>MUIC Account :</b> {{ $keycloak.userName }}
                                </p>
                                <p  class="mt-0 mb-1 profile-font">
                                    <b>MU Account :</b> 
                                </p>
                            </b-card-text>
                        </b-card-body>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    export default {
        props: {
            MaxScale:String,
            role: {
                type: Array,
                required: true,
                default: () => []
            },
            windowWidth:Number
        },
        data() {
            return {
                imageView:'',
                photoProfile:null,
            }
        },
        mounted(){
            this.readPhotoFile()
        },
        methods: {
            ImageProfile(val) { return val !== null && val !== 'null' ? val : `@/assets/img/avatar.png` },
            async readPhotoFile(){
                try {
                    const res = this.$http.get(`/portal/profile/get_img/`,{ 'responseType': 'blob' }).then((res) => {
                        if(res.status === 200){
                            let blob = new Blob([res.data])
                            return this.imageView = this.ImageProfile(window.URL.createObjectURL(blob))
                        }else{
                            throw { res }
                        }
                    })
                } catch (error) {
                    return this.imageView = ''
                }
            },
            async UploadProfile(event){
                const sendPhoto = new FormData()
                sendPhoto.append('pic', event.target.files[0]);
                try {
                    const res = this.$http.post(`/portal/profile/update_img/`,sendPhoto,{ 'responseType': 'blob' }).then((res) => {
                        if(res.status === 200){
                            this.readPhotoFile()
                        }
                    })
                } catch (error) {}
            },
        }
    }
</script>

<style lang="scss" scoped>
    .card-announ{
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        // border-radius: 20px;
    }
    .bg-card{
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg_portal-profile.png");
    }
    .f-500{ font-weight: 500; }
    // .profile-font{ font-family: 'Baloo Tamma 2', cursive; }
    .imgStyle{ width: 120px; height: 120px; }
    .imgStyleMini{ width: 100px; height: 100px; }
    .font-btn-upload{ font-family: 'Baloo Tamma 2', cursive; font-size: 0.7rem; }
    .card-profileImage{
        border:0px;
        background-color: #000;
        box-shadow: 0 4px 8px 0 #000;
    }
    // .avatar-image{
    //     margin-left: 17px;
    //     margin-top: -21px;
    // }
    // .avatar-imageMini{
    //     margin-left: 24px;
    //     margin-top: 46px;
    // }
    // .avatar-image-1800 {
    //     margin-left: 20px;
    //     margin-top: 5px;
    // }
</style>